
import Navbar from 'components/navbar'
import $global from 'stores/global'
export default {
  components: {Navbar},
  data(){
    return {
      key: 0,
    }
  },
  computed: {
    loaded() {
      return $global.loaded
    }
  },
  watch: {
    '$route.fullPath'() {
      if (this.$route.name === 'settings' || this.$route.name === 'pulse' || this.$route.name === 'new-chat') return
      this.key++
    }
  },
  created() {
    this.$listen('toggle-burger', () => {
      this.$refs.navbar.toggleBurger()
    })
  }
}
